import { render, staticRenderFns } from "./widget-doctype.vue?vue&type=template&id=301da7cb&"
import script from "./widget-doctype.vue?vue&type=script&lang=js&"
export * from "./widget-doctype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports